<div class="pb-13">
  <app-discover-fund-avatar
    class="mb-3"
    [fund]="funding!"
    [showDefaultIcon]="false"
    size="36px"
  ></app-discover-fund-avatar>
  <div class="mb-1 text-3xl font-bold">
    {{ funding?.title }}
  </div>
  @if (funding?.mname) {
    <span class="block mb-2">
      {{ funding?.mname }}
    </span>
  }
  <div class="flex gap-2">
    @for (fundingTag of getFundingTags(funding!); track fundingTag.id) {
      <span bp-tag class="inline-flex items-center h-5 gap-1 text-sm whitespace-nowrap">
        @if (fundingTag.tag?.iconClass?.value && fundingTag.tag?.iconClass?.value !== '') {
          <mat-icon
            class="text-inherit icon-size-3"
            [svgIcon]="(fundingTag.tag?.iconClass)!.value"
          ></mat-icon>
        }
        {{ fundingTag.tag?.shortName?.value }}
      </span>
    }
  </div>

  <!-- <div>
    <div
      class="text-2xl font-bold"
      [bp-skeleton]="!fundingShareValues"
      skeletonHeight="12"
      skeletonWidth="24"
      skeletonExtraClass="mt-1"
    >
      @if (fundingShareValues && fundingShareValues?.length) {
        <span>
          {{
            getLastShareValue()
              | currency
                : currencyFund?.currencyCode
                : currencyFund?.display
                : currencyFund?.digitsInfo
          }}
        </span>
      }
    </div>
  </div> -->

  @if (profitabilityValue) {
    <div
      class="flex flex-row gap-1 mt-2 transition-opacity duration-200 ease-in-out"
      [ngClass]="{
        'opacity-30': isLoading,
        'opacity-100': !isLoading,
      }"
    >
      <!-- [ngClass]="{
          'text-charts-green-700': (profitabilityValue?.allTimeNumber || 0) > 0,
        }" -->
      <span class="flex items-center justify-start gap-2">
        <span class="font-semibold">
          @if (profitabilityValue?.allTimeNumber) {
            <mat-icon
              class="icon-size-3.5 text-inherit"
              svgIcon="heroicons_mini:arrow-long-{{
                (profitabilityValue?.allTimeNumber || 0) > 0 ? 'up' : 'down'
              }}"
            ></mat-icon>
          }
          {{ profitabilityValue?.alltime }}
        </span>
      </span>
      <span bp-text-values-card> variación {{ periodTimeTitle[periodTime] }} </span>
    </div>
  }

  <section class="my-2">
    @defer (when fundingShareValues && currencyFund && funding; prefetch on immediate) {
      <app-funding-share-value-graph
        [height]="heightChart"
        [funding]="funding"
        [currency]="currencyFund"
        [fundingShareValues]="fundingShareValues!"
        (periodTimeControlChange)="getShareValues(funding!.id, $event)"
      ></app-funding-share-value-graph>
    } @placeholder (minimum 30ms) {
      <div class="w-full bg-white" [ngStyle]="{ height: heightChart + 100 + 'px' }"></div>
    }
  </section>
  @if (!isFundingDetail) {
    <section class="flex w-full my-3 sm:hidden">
      @if (!isCustomFundAdded) {
        <button
          (click)="addCustomCategoryFund.emit()"
          class="flex w-full gap-2"
          color="primary"
          @fadeIn
          mat-flat-button
        >
          <mat-icon [svgIcon]="'mat_outline:add'"></mat-icon>
          Agregar a mi portafolio
        </button>
      }
      @if (isCustomFundAdded) {
        <button
          @fadeIn
          (click)="removeCustomCategoryFund.emit()"
          class="flex w-full gap-2 bg-white"
          color="warn"
          mat-button
        >
          <mat-icon [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
          Quitar de mi portafolio
        </button>
      }
    </section>
  }
  <div class="flex flex-col gap-3">
    <section class="flex-row px-0 py-2 mx-0">
      <p class="mb-1 text-lg font-semibold">Descripción {{ funding?.mnemonic }}</p>
      <p class="flex-col px-0 py-0 my-0">
        {{ funding?.description }}
      </p>
    </section>
    <section>
      <p class="mb-1 text-lg font-semibold">Características</p>

      @for (
        feature of funding?.features?.length! > 0 ? funding?.features : funding?.featuresjson;
        track feature
      ) {
        <p class="flex flex-row my-1">
          <span class="col-auto mr-2">
            <i class="fas fa-check text-primary"></i>
          </span>
          <span class="px-0 col-10">
            <span class="underline">{{ goalFundingService.getFeaturesSplit(feature, 0) }}</span>
            :
            <span>{{ goalFundingService.getFeaturesSplit(feature, 1) }}</span>
          </span>
        </p>
      }
    </section>
    @if (funding?.additionalDescription !== '') {
      <mat-expansion-panel
        class="pr-1 mx-0 mb-3 bg-transparent shadow-none text-accent legacy"
        togglePosition="after"
        (opened)="scrollToExpansionPanel(buttonSection)"
        #expansionPanel
      >
        <mat-expansion-panel-header
          class="h-auto px-0 py-2 hover:bg-transparent text-accent legacy"
          [collapsedHeight]="'56px'"
        >
          <mat-panel-title class="flex gap-1 mr-2">
            <p class="mb-1 text-lg font-semibold">¿Por qué esta clase de activos?</p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="flex-col px-0 py-0 my-0">
          {{ funding?.additionalDescription }}
        </p>
      </mat-expansion-panel>

      <!-- <section class="mb-3">
        <p class="mb-1 text-lg font-semibold">¿Por qué esta clase de activos?</p>
        <p class="flex-col px-0 py-0 my-0">
          {{ funding?.additionalDescription }}
        </p>
      </section> -->
    }
  </div>

  <div #buttonSection class="flex flex-col gap-2">
    @if (funding?.informativeBrochureId?.value || funding?.informativeBrochureUrl !== '') {
      <a [href]="getBrochureUrl(funding!)" target="_blank" rel="noopener noreferrer">
        <button class="flex w-full gap-2 mt-3" mat-stroked-button @fadeIn>
          <mat-icon [svgIcon]="'heroicons_outline:document-plus'"></mat-icon>
          Ver folleto
        </button>
      </a>
    }
    @if (!isFundingDetail) {
      <section class="hidden w-full my-3 sm:flex">
        @if (!isCustomFundAdded) {
          <button
            (click)="addCustomCategoryFund.emit()"
            class="flex w-full gap-2"
            color="primary"
            @fadeIn
            mat-flat-button
          >
            <mat-icon [svgIcon]="'mat_outline:add'"></mat-icon>
            Agregar a mi portafolio
          </button>
        }
        @if (isCustomFundAdded) {
          <button
            @fadeIn
            (click)="removeCustomCategoryFund.emit()"
            class="flex w-full gap-2 bg-white"
            color="warn"
            mat-button
          >
            <mat-icon [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
            Quitar de mi portafolio
          </button>
        }
      </section>
    }
  </div>
</div>
